import { configuredApiOrigin } from '../../../shared/config/api-origin';
import { createLiveMissionTemplateAdapter } from '../../mission-workspace/template/adapters/live-mission-template-adapter';
import type { MissionTemplateReadPort } from '../../mission-workspace/template/consumer/contract';
import { exactPin } from '../../mission-workspace/template/consumer/contract';
import { readMissionTemplate } from '../../mission-workspace/template/consumer/reader';
import { projectMissionTemplate } from '../../mission-workspace/template/domain/projection';
import { scenarioProvenance } from './source-bound-scenario';
export const associatedMissionTemplatePin = exactPin(scenarioProvenance.missionTemplatePin);
/** Dev loopback, or the origin from `.env.main` when a production API is configured. */
export function associatedMissionTemplatePort(
  origin: string | undefined,
  development: boolean,
): MissionTemplateReadPort | null {
  if (!origin || (!development && configuredApiOrigin() === null)) return null;
  return createLiveMissionTemplateAdapter({ baseOrigin: origin });
}
export async function readAssociatedMissionTemplate(port: MissionTemplateReadPort) {
  return projectMissionTemplate(await readMissionTemplate(port, associatedMissionTemplatePin));
}
/** A new request or unmount invalidates late responses. */
export class AssociationSequence {
  private sequence = 0;
  begin() {
    return ++this.sequence;
  }
  current(ticket: number) {
    return ticket === this.sequence;
  }
  invalidate() {
    this.sequence++;
  }
}
